import { useRef, useCallback } from "react";
import usePrefersReducedMotion from "./usePrefersReducedMotion";

/** Subtle desktop-only magnetic hover for CTAs. */
export default function useMagneticEffect(strength = 0.28) {
  const ref = useRef(null);
  const reduced = usePrefersReducedMotion();

  const onMouseMove = useCallback(
    (event) => {
      if (reduced || !ref.current) return;
      const rect = ref.current.getBoundingClientRect();
      const x = event.clientX - rect.left - rect.width / 2;
      const y = event.clientY - rect.top - rect.height / 2;
      ref.current.style.transform = `translate(${x * strength}px, ${y * strength}px)`;
    },
    [reduced, strength],
  );

  const onMouseLeave = useCallback(() => {
    if (!ref.current) return;
    ref.current.style.transform = "translate(0, 0)";
  }, []);

  return { ref, onMouseMove, onMouseLeave, disabled: reduced };
}
